module.exports = __webpack_public_path__ + "img/teamImg3.828d0595.jpg";